/**
 * Shared phase identity + instruction copy for the in-video TranscriptCoachmark,
 * used by the lesson player and the feed. Kept in its own module (not the
 * component file) so the component stays component-only for Vite Fast Refresh.
 */
export type TranscriptCoachmarkPhase = "word_click" | "phrase_highlight";

/** Instruction copy per phase — the single source for both surfaces. */
export const PHASE_TITLES: Record<TranscriptCoachmarkPhase, string> = {
  word_click: "Tap words to translate",
  phrase_highlight: "Highlight phrases to translate",
};
